import { SESSION_STORAGE_KEY } from '../constant/Constant';
import SessionStorageUtil from './SessionStorageUtil';

class ConfigUtil {
    static getWebType() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).webType;
    }

    static getExternalLink_PrivacyPolicy() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).externalLink.privacyPolicy;
    }

    static getExternalLink_Home() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).externalLink.home;
    }

    static getExternalLink_Directions() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).externalLink.directions;
    }

    static getExternalLink_Curriculum() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).externalLink.curriculum;
    }

    static getCaptchaSiteKey() {
        return SessionStorageUtil.get(SESSION_STORAGE_KEY.CONFIG).captchaSiteKey;
    }
}

export default ConfigUtil;
